module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "clientes"
    }
  }, [_c('div', {
    staticClass: "col-md-12 flecha-container"
  }, [_c('h1', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_vm._v("CLIENTES")]), _vm._v(" "), _c('img', {
    staticClass: "flecha",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1500",
      "src": require("imgs/icons/Flecha_Blanca.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clientes-industrasdiv"
  }, [_c('h2', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_vm._v("INDUSTRIAS")]), _vm._v(" "), _c('hr', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "paragaphs-conainer",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    attrs: {
      "src": require("imgs/icons/Servimos_Papel.png")
    }
  }), _c('p', [_c('b', [_vm._v("PAPEL")]), _c('br'), _vm._v(" Empresas que se dedican a la fabricación y manufactura de papel (sanitario, papel para dispensadores, toallas y servilletas de cocina). Entre nuestros clientes tenemos a Papelera San Francisco, S.A. de C.V. ")])]), _vm._v(" "), _c('div', {
    staticClass: "paragaphs-conainer",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    attrs: {
      "src": require("imgs/icons/Servimos_Zanahoria.png")
    }
  }), _c('p', [_c('b', [_vm._v("AGRÍCOLA")]), _c('br'), _vm._v("Empresas enfocadas a los productos alimenticios en general como Vilore Foods Inc. y Green Heart Farms Inc.")])]), _vm._v(" "), _c('div', {
    staticClass: "paragaphs-conainer",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    attrs: {
      "src": require("imgs/icons/Servimos_Jugo.png")
    }
  }), _c('p', [_c('b', [_vm._v("EMBOTELLADORA")]), _c('br'), _vm._v("Empresas orientadas a embotellar refrescos, jugos, aguas, etc. Dentro de nuestros clientes contamos con Jumex, S.A. de C.V., Arca Continental, Tetrapak, entre otros.")])]), _vm._v(" "), _c('div', {
    staticClass: "paragaphs-conainer",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    attrs: {
      "src": require("imgs/icons/Servimos_Herramientas.png")
    }
  }), _c('p', [_c('b', [_vm._v("EMPAQUETADORA")]), _c('br'), _vm._v(" Empresas enfocadas a la fabricación de material para empaque y embalaje. Entre nuestros clientes se encuentra Calibaja Manufacturing y Knight Logistics. \n")])])]), _vm._v(" "), _c('div', {
    staticClass: "clientes-empresasdiv"
  }, [_c('h2', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_vm._v("EMPRESAS")]), _vm._v(" "), _c('hr', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "carousel slide media-carousel",
    attrs: {
      "id": "media"
    }
  }, [_c('div', {
    staticClass: "carousel-inner"
  }, [_c('div', {
    staticClass: "item  active"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "thumbnail",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": require("imgs/icons/Empresa_coyote.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "thumbnail",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": require("imgs/icons/Empresa_Greenheart.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "thumbnail",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": require("imgs/icons/Empresa_Knight.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "thumbnail",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": require("imgs/icons/Empresa_PSF.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "thumbnail",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": require("imgs/icons/Empresa_TQL.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "thumbnail",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": require("imgs/icons/Empresa_Vilore.png")
    }
  })])])])])]), _vm._v(" "), _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "data-slide": "prev",
      "href": "#media"
    }
  }, [_vm._v("‹")]), _vm._v(" "), _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "data-slide": "next",
      "href": "#media"
    }
  }, [_vm._v("›")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a357664"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/clientes.vue
// module id = 81
// module chunks = 0